import Base from './base.js';

export default class ToolType extends Base{
}